import { ChangeDetectorRef, Directive, Input } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';
import { FormGroup } from '@angular/forms';
import { CalculatorInputManager } from '../common/calculator-input-manager';
import { PriceService } from '../../../../services/price.service';
import { CalculatorPrivacyStatus } from '../../../models/price/calculator-privacy-status';
import { AnalysisService } from '../../../../services/analysis.service';
import { LoaderService } from '../../../../services/loader.service';
import { CsvParserService } from '../../../../services/csv-parser.service';
import { ToastService } from '../../../../services/toast.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { DocumentService } from '../../../../services/document.service';

@Directive()
export abstract class AbstractCalculatorComponentDirective extends UnsubscribeOnDestroyAdapter {
  @Input() formGroup: FormGroup;
  @Input() advanced: boolean;
  @Input() manager: CalculatorInputManager;

  constructor(
    protected priceService: PriceService,
    protected analysisService: AnalysisService,
    protected loadingService: LoaderService,
    protected csvParser: CsvParserService,
    protected toastService: ToastService,
    protected authService: AuthService,
    protected changeDetector: ChangeDetectorRef,
    protected documentService: DocumentService,
  ) {
    super();
  }

  protected getCalculatorPrivacyStatus() {
    return this.advanced ? CalculatorPrivacyStatus.PUBLIC_ALL : CalculatorPrivacyStatus.PUBLIC_BASIC;
  }
}
